export default __webpack_public_path__ + "static/4-bd4bdc6ec8da22e55b1a04ac96435a1b.png";